export default __webpack_public_path__ + "static/media/marketing mapa page- hero element.bda1f57d.png";